import React, { Component, useRef, useState } from "react";
import Header from "../../common/Header";
import FullCalenderComponent from "../../common/FullCalenderComponent";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import {
  getEventList,
  getProgramEventList,
  getRunnerProgramList,
} from "../../../apis/eventService";
import ApplicationUtil from "../../../utils/ApplicationUtil";
import {
  Checkbox,
  FormControlLabel,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import SubmitCancelBtn from "../../common/SubmitCancelBtn";
import AppToolBar from "../../common/AppToolBar";
import moment from "moment";
import httpService from "../../../apis/httpService";
import eventImg from "../../../images/Run.png";
import ApplicationConstants from "../../../constants/ApplicationConstants";
import RunnerSideBreadcrumbs from "../../common/RunnerSideBreadcrumbs";

import restImage from "../../../images/comfort-zone.png";
import { Visibility } from "@material-ui/icons";
export const INITIAL_EVENTS = [
  {
    id: 1,
    title: "Cooper Test 1",
    start: "2023-11-26",
    end: "2023-12-03",
    fontSize: "20px",
    extendedProps: {
      eventDetails: {
        name: "Cooper Test",
        dateFrom: "26-11-2023",
        dateTo: "03-12-2023",
        category: "Distance - 2km",
      },
    },
  },

  {
    id: 103,
    title: "Cooper Test - Run 1",
    start: "2023-11-28 06:40:00",
    end: "2023-11-28",

    display: "block",
    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "distance,completionTime",
        distance: 2000,
        completionTime: "00:12:00",
      },
    },
  },
  {
    display: "block",
    id: 210,
    start: "2023-11-27 05:00:00",
    title: "Yoga Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Tuesday",
      time: "5:00am - 6:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 211,
    start: "2023-11-29 10:00:00",
    title: "Nutrition Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Tuesday",
      time: "10:00am - 11:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 212,
    start: "2023-12-01 16:00:00",
    title: "Mental Awareness",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Tuesday",
      time: "4:00pm - 5:00pm",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },

  {
    id: 202,
    title: "Stepathlon",
    start: "2023-12-10",
    end: "2024-01-01",
    backgroundColor: "brown",
    extendedProps: {
      eventDetails: {
        name: "Stepathlon",
        dateFrom: "10-12-2023",
        dateTo: "01-01-2024",
        category: "Steps - 10000",
      },
    },
  },
  {
    id: 203,
    title: "STEP - 2nd day",
    start: "2023-12-10 06:40:00",
    end: "2023-12-10",
    display: "block",
    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 4000,
      },
    },
  },
  {
    id: 204,
    title: "STEP - 3rd day",
    start: "2023-12-11 06:40:00",
    end: "2023-12-11",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 6000,
      },
    },
  },
  {
    id: 205,
    title: "STEP - 4th day",
    start: "2023-12-12",
    end: "2023-12-12",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 8000,
      },
    },
  },
  {
    id: 206,
    title: "STEP - 5th day",
    start: "2023-12-13 07:40:00",
    end: "2023-12-13",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 8000,
      },
    },
  },
  {
    id: 207,
    title: "STEP - 6th day",
    start: "2023-12-14 06:30:00",
    end: "2023-12-14",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 10000,
      },
    },
  },
  {
    id: 208,
    title: "STEP - 7th day",
    start: "2023-12-15 06:20:00",
    end: "2023-12-15",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 12000,
      },
    },
  },
  {
    id: 209,
    title: "STEP - 8th day",
    start: "2023-12-16 06:10:00",
    end: "2023-12-16",
    display: "block",

    backgroundColor: "#ffa600",
    borderColor: "#ffa600",
    extendedProps: {
      activity: {
        displayColumns: "target,achieved",
        target: 10000,
        achieved: 14000,
      },
    },
  },
  {
    display: "block",
    id: 220,
    start: "2023-12-12",
    title: "Yoga Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Tuesday",
      time: "07:00pm - 08:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 221,
    start: "2023-12-18 12:00:00",
    title: "Nutrition Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Monday",
      time: "12:00pm - 01:00pm",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 223,
    start: "2023-12-28 05:00:00",
    title: "Yoga Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Thursday",
      time: "05:00am - 06:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 224,
    start: "2023-12-14 17:00:00",
    title: "Nutrition Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Thursday",
      time: "05:00pm - 06:00pm",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 225,
    start: "2023-12-04 06:00:00",
    title: "Yoga Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Monday",
      time: "06:00am - 07:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 226,
    start: "2023-12-09 10:00:00",
    title: "Nutrition Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Saturday",
      time: "10:00am - 11:00am",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    display: "block",
    id: 227,
    start: "2024-01-02 18:00:00",
    title: "Mental Wellness Session",
    backgroundColor: "#a7c957",
    borderColor: "#a7c957",
    extendedProps: {
      day: "Tuesday",
      time: "06:00pm - 07:00pm",
      meetingLink: "https://meet.google.com/iqg-wwsx-kxw",
    },
  },
  {
    id: 5,
    title: "Cooper Test 2",
    start: "2024-01-01",
    end: "2024-01-07",
    extendedProps: {
      eventDetails: {
        name: "Cooper Test 2",
        dateFrom: "01-01-2024",
        dateTo: "07-01-2024",
        category: "Distance - 2 Km",
      },
    },
  },
];
function CalenderHomeView(props) {
  const { classes, history } = props;
  const [calenderEvents, setCalenderEvents] = useState(INITIAL_EVENTS);
  const [selectedEventDetails, setSelectedEventDetails] = useState({});

  const [selectedDayCellContent, setSelectedDayCellContent] = useState({});
  const [programDetails, setProgramDetails] = useState({});
  const calendarRef = useRef();
  const API_URL_FILE = httpService.API_URL();

  const handleEventClick = (info) => {
    if (window.innerWidth < 600) {
      setSelectedEventDetails(info);
    } else if (info?.view?.type !== "weekProgram") {
      setSelectedEventDetails(info);
    }
  };
  const handleEvents = (info) => {};
  const handleCalenderViewDate = (info) => {
    localStorage.removeItem("navigateToCalender");
    let programDetails = ApplicationUtil.getRunnersProgramDetails();

    let params = {
      programId: programDetails?.id,
    };
    getRunnerProgramList(params).then(({ data }) => {
      setProgramDetails(data);
      let eventDTO = data?.eventDTO;
      let sessions = data?.programSessions;
      let activityLists = [];
      let calenderData = [];
      for (let i = 0; i < eventDTO?.length; i++) {
        let event = eventDTO[i];
        let activityLists = event?.activityList;

        let targetTimeList = event?.eventTargetTimeList;
        // if(event?.activityList?.length > 0){
        //   activityLists = [...activityLists, ...event.activityList]
        // }
        // let trainingPlan = data[i]?.trainingPlan;
        // let result = data[i]?.result;
        // let color = this.dynamicColors()
        if (event) {
          let object = {};
          object.id = event?.id;
          object.title = event?.name;
          object.challengeType = event?.challengeType;
          object.start = event?.localStartDate;
          object.end = moment(event?.localEndDate)
            .add(1, "day")
            .format("YYYY-MM-DD");
          object.fontSize = "20px";
          object.editable = false;
          object.extendedProps = {
            programDetails: {
              name: event?.name,
              dateFrom: ApplicationUtil.changeDateFormat(event?.localStartDate),
              dateTo: ApplicationUtil.changeDateFormat(event?.localEndDate),
              category: `${event?.eventRunCategories[0]?.categoryName} - ${
                event?.targetedSteps || event?.eventRunCategories[0]?.category
              }`,
              details: event,
              organizers: data?.organizers,
              image: data?.imageDto,
              eventTargetTimeList: targetTimeList ? targetTimeList : [],
            },
          };
          // object.backgroundColor = color
          calenderData.push(object);
        }

        // =========================================================
        //                      Target Time events
        // =========================================================
        if (targetTimeList?.length > 0) {
          for (let j = 0; j < targetTimeList?.length; j++) {
            let activity = targetTimeList[j];
            let object = {};

            object.id = activity?.id;
            object.title = "title";
            object.start = activity?.dayOfActivity;
            object.end = activity?.dayOfActivity;
            object.display = "block";
            object.fontSize = "20px";
            object.editable = false;
            object.backgroundColor = "#3788d8";
            object.borderColor = "#3788d8";
            let displayColumns = activity?.displayColumns?.includes("steps")
              ? "targetTime,activeTime"
              : // : activity?.cooperTestRemark
                // ? activity?.displayColumns.concat(",remark")
                "targetTime,activeTime";

            object.extendedProps = {
              activity: {
                displayColumns,
                details: activity,
                category: "timeShow",
                targetedSteps: 0,
              },
              eventDetails: event,
            };
            calenderData.push(object);
          }
        }
        if (activityLists?.length > 0) {
          for (let j = 0; j < activityLists?.length; j++) {
            let activity = activityLists[j];
            let object = {};
            object.id = activity?.id;
            object.title = activity?.name || activity?.type;
            object.start = ApplicationUtil.changeDateFormatDate(
              activity?.startDateLocal
            );
            object.display = "block";
            object.fontSize = "20px";
            object.editable = false;
            object.backgroundColor = activity?.valid ? "#ffa600" : "#D04848";
            object.borderColor = activity?.valid ? "#ffa600" : "#D04848";
            let displayColumns = activity?.displayColumns?.includes("steps")
              ? "target,achieved"
              : // : activity?.cooperTestRemark
                // ? activity?.displayColumns.concat(",remark")
                activity?.displayColumns;
            if (
              event.challengeType ===
              ApplicationConstants.challengeTypeList[6].value
            ) {
              displayColumns = "steps,completionTime";
            }
            object.extendedProps = {
              activity: {
                displayColumns,
                details: activity,
                target: activity?.displayColumns?.includes("steps")
                  ? event?.targetedSteps
                    ? event?.targetedSteps
                    : event?.eventRunCategories[0]?.category
                  : "",
                targetedSteps: event?.targetedSteps,
              },
              eventDetails: event,
            };
            calenderData.push(object);
          }
        }

        // if (targetTimeList?.length > 0) {
        //   for (let k = 0; k < targetTimeList?.length; k++) {
        //     let activity = targetTimeList[k];

        //     let object = {};
        //     object.id = activity?.id;
        //     object.title = "title";
        //     object.challengeType = "STAIR_STEPPER";
        //     object.start = ApplicationUtil.changeDateFormatDate(
        //       activity?.dayOfActivity
        //     );
        //     object.end = ApplicationUtil.changeDateFormatDate(
        //       activity?.dayOfActivity
        //     );

        //     object.display = "block";
        //     object.fontSize = "20px";
        //     object.editable = false;
        //     object.backgroundColor = activity?.valid ? "#ffa600" : "#D04848";
        //     object.borderColor = activity?.valid ? "#ffa600" : "#D04848";
        //     let displayColumns = activity?.displayColumns?.includes("steps")
        //       ? "targetTime,achieved"
        //       : // : activity?.cooperTestRemark
        //         // ? activity?.displayColumns.concat(",remark")
        //         "targetTime";
        //     if (
        //       event.challengeType ===
        //       ApplicationConstants.challengeTypeList[6].value
        //     ) {
        //       displayColumns = "targetTime";
        //     }
        //     object.extendedProps = {
        //       activity: {
        //         displayColumns,
        //         target: "100",
        //         details: activity,
        //         eventDetails: event,
        //         targetedSteps: event?.targetedSteps,
        //       },
        //       eventDetails: event,
        //     };

        //     calenderData.push(object);
        //   }
        // }
      }

      if (sessions) {
        for (let i = 0; i < sessions?.length; i++) {
          let session = sessions[i];
          // let trainingPlan = data[i]?.trainingPlan;
          // let result = data[i]?.result;
          // let color = this.dynamicColors()
          if (session && session?.name) {
            let object = {};
            object.id = session?.id;
            object.title = session?.name;
            object.start = ApplicationUtil.changeDateFormatDate(
              session?.sessionStartDate
            );
            object.end = ApplicationUtil.changeDateFormatDate(
              session?.sessionStartDate
            );
            object.fontSize = "20px";
            object.editable = false;
            object.extendedProps = {
              sessionDetails: {
                day: moment(
                  ApplicationUtil.changeDateFormatDate(
                    session?.sessionStartDate
                  )
                ).format("dddd"),
                time: `${moment(
                  `${ApplicationUtil.changeDateFormatDate(
                    session?.sessionStartDate
                  )} ${session?.sessionStartDate?.split(" ")[1]}`
                ).format("LT")} - ${moment(
                  `${ApplicationUtil.changeDateFormatDate(
                    session?.sessionEndDate
                  )} ${session?.sessionEndDate?.split(" ")[1]}`
                ).format("LT")}`,
                endDate: `${moment(
                  `${ApplicationUtil.changeDateFormatDate(
                    session?.sessionEndDate
                  )} ${session?.sessionEndDate?.split(" ")[1]}`
                ).format("L LT")}`,
                meetingLink: session?.meetingLink,
                faculty: session?.facultyName || "",
              },
            };
            // object.backgroundColor = color
            calenderData.push(object);
          }
        }
      }

      setCalenderEvents(calenderData);
    });
  };
  const dynamicColors = function () {
    return (
      "hsl(" +
      360 * Math.random() +
      "," +
      (25 + 70 * Math.random()) +
      "%," +
      (65 + 10 * Math.random()) +
      "%)"
    );
  };
  const uniqueId = () => {
    const dateString = Date.now().toString(36);
    const randomness = Math.random().toString(36).substr(2);
    return dateString + randomness;
  };
  //   handleEventHover = (info) => {
  // console.log('mouse hover',info.event._def.publicId)
  // this.setState({eventHoverDetails:info})
  //   }
  //   handleEventMouseLeave = (info) => {
  //     console.log('mouse leave',info)
  //     this.setState({eventHoverDetails:{}})

  //   }
  const handleEventMount = (info) => {
    info.el.setAttribute("id", `event-${info.event.id}`);
  };
  const weekSessionView = (info) => {
    let { sessionDetails } = info?.event?.extendedProps;
    let programTitle = info.event?.title;
    let endDate = sessionDetails?.endDate;
    let currentDate = moment().format("L");
    let isSessionOver = moment(endDate).isAfter(currentDate);

    let html = `<div class='fc-htmlEventContent'>
    <div style='display:flex; align-items:flex-start'>
    <img src='https://www.shutterstock.com/image-vector/yoga-logo-vector-emblem-260nw-571076140.jpg' alt='yoga' height=30 width=30 style='border-radius:50%; object-fit:cover' class='fc-laptopContent'/>
    <img src='https://www.shutterstock.com/image-vector/yoga-logo-vector-emblem-260nw-571076140.jpg' alt='yoga' height=30 width=30 style='border-radius:50%; object-fit:cover' class='fc-mobileLogo'/>
   <div style='margin-left:5px; margin-bottom:5px' class='fc-laptopContent'>
    <p class='fc-htmlEventContent-span'>Time: <span>${
      sessionDetails?.time
    }</span> </p>
   
   <p class='fc-htmlEventContent-span'>Day: <span>${
     sessionDetails?.day
   }</span></p>
    </div>
    </div>
    <p class='fc-htmlEventContent-span-title fc-laptopContent'>${programTitle}</p>
   
    <p class='fc-htmlEventContent-span fc-laptopContent'>Faculty: <span>${
      sessionDetails?.faculty
    }</span></p>
   
    ${
      sessionDetails?.meetingLink && isSessionOver
        ? `<a class='join-link fc-laptopContent' target='_blank' href=${sessionDetails?.meetingLink}>Join Here</a>`
        : ""
    }
    </div>`;
    return html;
  };
  const weekProgramDetailsView = (info) => {
    let { programDetails } = info?.event?.extendedProps;

    let challengeType = info?.event?.extendedProps?.challengeType;

    let html = `<div class='fc-htmlEventContent'>
   

    <div style='display:flex; align-items:center'>
    <img src=${
      programDetails?.organizers
        ? `${API_URL_FILE}${programDetails?.organizers[0]?.organizerLogo}`
        : eventImg
    } alt='yoga' class='fc-laptopContent' height=30 width=30 style='border-radius:50%; object-fit:cover' />
    <img src=${
      programDetails?.organizers
        ? `${API_URL_FILE}${programDetails?.organizers[0]?.organizerLogo}`
        : eventImg
    } alt='yoga' height=30 width=30 style='border-radius:50%; object-fit:cover' class='fc-mobileLogo'/>
    <div style='margin-left:10px;' >
    <p class='fc-htmlEventContent-span fc-laptopContent'>From: <span>${
      programDetails?.dateFrom
    }</span></p>
 
    <p class='fc-htmlEventContent-span fc-laptopContent'>To: <span>${
      programDetails?.dateTo
    }</span></p>
    </div>
    </div>
    <p class='fc-htmlEventContent-span-title fc-laptopContent'>${
      info.event.title
    }</p>
    <p class='fc-htmlEventContent-span fc-laptopContent'>${
      programDetails?.category && challengeType !== "STAIR_STEPPER"
        ? `${programDetails?.category}`
        : ""
    }</p>
    

    </div>`;

    // return {
    //   dayCellContent,
    //   eventContent:html
    // }

    return html;
  };

  const weekActivityView = (info) => {
    let { activity, programDetails, eventDetails } = info?.event?.extendedProps;
    const targetedSteps = info?.event?.extendedProps?.activity?.targetedSteps;

    let title = info.event.title;
    let isValid = activity?.details?.valid;
    let challengeType = eventDetails?.challengeType;
    let html;
    if (activity.category === "timeShow") {
      if (!activity?.details?.targetTime) {
        html = `<div class='fc-htmlEventContent restDay' style='display:";'>
        <img
       src=${restImage}
       alt=""
       style='width:30px; height: 25px;'
     />
        <p  class='fc-htmlEventContent-span' style="margin:0px " >
       Rest Day </p> </div>`;
      } else {
        html = `<div class='fc-htmlEventContent'>
            <p  class='fc-htmlEventContent-span' style="fontSize:14px">
            ⏱️<span  class="textLabel">Target Time</span>:&nbsp;
             
           ${
             activity?.details?.targetTime ||
             "-" + `<span>&nbsp;Min.</span>` ||
             "-"
           }
           
          </p>
  
          <p  class='fc-htmlEventContent-span' style="fontSize:14px">
          🏅<span class="textLabel">Achieved Time</span>:&nbsp;
         
       ${activity?.details?.activeTime + `<span>&nbsp;Min.</span>` || "-"}
          
         </p>
  
          
        
    
   
    
    </div>`;
      }
    } else {
      html = `<div class='fc-htmlEventContent'>
  <p class='fc-htmlEventContent-span-title'>${title}</p>
  ${
    activity &&
    activity.displayColumns
      ?.split(",")
      .filter((x) => x)
      .map(
        (act) =>
          `
        <p key=${act} class='fc-htmlEventContent-span'>
          ${labels[act]}: 
         <span> ${
           act === "distance"
             ? isValid //if activity is valid
               ? activity?.details["cooperTestDistance"]
                 ? parseFloat(
                     activity?.details["cooperTestDistance"] / 1000
                   ).toFixed(2) + " km"
                 : `0 km`
               : //if activity is not valid
               activity?.details["distance"]
               ? parseFloat(activity?.details["distance"] / 1000).toFixed(2) +
                 " km"
               : `0 km`
             : //  : act === "remark"
             //  ? activity?.details["cooperTestRemark"]
             act === "target"
             ? activity?.target
             : act === "achieved"
             ? activity?.details["steps"]
             : activity?.details[act]
             ? activity?.details[act]
             : `00:00:00`
           //ankit  Defect_id_485 : if completion time is not send by api set to zero
         }
          </span>
        </p>
        `
      )
      .join("")
  }
  <p class='fc-htmlEventContent-span'><span>${
    !isValid ? "Invalid activity" : ""
  }</span></p>
  </div>`;
    }

    return html;
  };

  const weekProgramEventContent = (info) => {
    if (info?.view?.type === "weekProgram") {
      let eventHtml = "";
      let sessionHtml = "";
      let activityHtml = "";

      if (info.event.extendedProps?.activity) {
        activityHtml += weekActivityView(info);
      }

      if (info.event.extendedProps?.programDetails) {
        eventHtml += weekProgramDetailsView(info);
      }
      if (info.event.extendedProps?.sessionDetails) {
        sessionHtml += weekSessionView(info);
      }

      return {
        html: info.event?.extendedProps?.sessionDetails
          ? sessionHtml
          : info.event.extendedProps?.activity
          ? activityHtml
          : eventHtml,
      };
    }
    if (info?.view?.type === "monthProgram") {
      let eventHtml = "";
      let sessionHtml = "";
      let activityHtml = "";

      if (info.event.extendedProps?.activity) {
        activityHtml += weekActivityView(info);
      }

      if (info.event.extendedProps?.programDetails) {
        eventHtml += weekProgramDetailsView(info);
      }
      if (info.event.extendedProps?.sessionDetails) {
        sessionHtml += weekSessionView(info);
      }

      return {
        html: info.event?.extendedProps?.sessionDetails
          ? sessionHtml
          : info.event.extendedProps?.activity
          ? activityHtml
          : eventHtml,
      };
    }
    if (info?.view?.type === "wholeProgram") {
      let eventHtml = "";
      let sessionHtml = "";
      let activityHtml = "";

      if (info.event.extendedProps?.activity) {
        activityHtml += weekActivityView(info);
      }

      if (info.event.extendedProps?.programDetails) {
        eventHtml += weekProgramDetailsView(info);
      }
      if (info.event.extendedProps?.sessionDetails) {
        sessionHtml += weekSessionView(info);
      }

      return {
        html: info.event?.extendedProps?.sessionDetails
          ? sessionHtml
          : info.event.extendedProps?.activity
          ? activityHtml
          : eventHtml,
      };
    }
  };
  const navigateToResults = () => {
    history.push("/programResults");
  };

  const handleClickDayCell = (data) => {
    setSelectedDayCellContent(data);
  };

  // const renderDayCellContent = (data) => {
  //   const event = calenderEvents.find(
  //     (event) =>
  //       moment(data.date).format("YYYY-MM-DD") >= event.start &&
  //       moment(data.date).format("YYYY-MM-DD") < event.end
  //   );

  //   if (event && event?.challengeType === "STAIR_STEPPER") {
  //     let isPresentRecord =
  //       event?.extendedProps?.programDetails?.eventTargetTimeList.find(
  //         (targetItem) => {
  //           if (
  //             targetItem.dayOfActivity ===
  //             moment(data.date).format("YYYY-MM-DD")
  //           ) {
  //             return targetItem;
  //           }
  //         }
  //       );

  //     return (
  //       <div>
  //         <p>{moment(data.date).format("DD")}</p>

  //         <div
  //           className="presentDayEvent fc-event fc-daygrid-event fc-daygrid-block-event fc-h-event"
  //           style={{ position: "relative" }}
  //           // onClick={() => handleClickDayCell(isPresentRecord)}
  //         >
  //           <span style={{ color: "white" }}>
  //             ⏱️ <span className="Labeltext">Target Time:&nbsp;</span>
  //             {isPresentRecord?.targetTime || "-"}
  //             {/* {moment(data.date).format("YYYY-MM-DD")} */}
  //           </span>

  //           <span style={{ color: "white" }}>
  //             <span className="Labeltext">Achieved Time:&nbsp;</span>{" "}
  //             {isPresentRecord?.activeTime || "-"}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  return (
    <>
      <AppToolBar>
        <Header
          label={
            `${programDetails?.name || ""} Calender` || "Wellness Calender"
          }
          {...props}
          showDrawer
          fromDate={ApplicationUtil.changeDateFormat(
            programDetails?.localStartDate
          )}
          toDate={ApplicationUtil.changeDateFormat(
            programDetails?.localEndDate
          )}
        />
      </AppToolBar>
      <div className={classes.calenderContainer}>
        <RunnerSideBreadcrumbs />
        <SubmitCancelBtn
          label={"Dashboard"}
          type={"submit"}
          onClick={() => history.push("/programDashboard")}
          style={{
            width: "160px",
          }}
        />
        {programDetails?.summaryGenerated && (
          <SubmitCancelBtn
            label={"Results"}
            type={"submit"}
            onClick={() => navigateToResults()}
            style={{
              width: "160px",
              marginLeft: "10px",
            }}
          />
        )}
        <FullCalenderComponent
          events={calenderEvents}
          // handleDateSelect={handleDateSelect}

          // renderEventContent={renderEventContent}
          handleEventClick={handleEventClick}
          handleEvents={handleEvents}
          calenderRef={calendarRef}
          handleCalenderViewDate={handleCalenderViewDate}
          views={{
            weekProgram: {
              type: "dayGridWeek", //'dayGridWeek',
              buttonText: "Week",

              // dayCellContent: (data) => {
              //   return renderDayCellContent(data);
              // },
              eventContent: (info) => {
                return weekProgramEventContent(info);
              },
              dayHeaderContent: (args) => {
                return moment(args.date).format("ddd Do");
              },

              dayMaxEventRows: 2,
              // duration: { days: 7 },
            },
            monthProgram: {
              type: "dayGridMonth",
              buttonText: "Month",
              // dayCellContent: (data) => {
              //   return renderDayCellContent(data);
              // },

              eventContent: (info) => {
                return weekProgramEventContent(info);
              },
              displayEventTime: false,
              dayMaxEventRows: 2,
              // duration: "month",
            },
            wholeProgram: {
              buttonText: "Program",
              type: "dayGridMonth",
              eventContent: (info) => {
                return weekProgramEventContent(info);
              },
              displayEventTime: false,
              dayMaxEventRows: 2,

              duration: {
                months: moment(programDetails.localEndDate).diff(
                  moment(programDetails.localStartDate),
                  "months",
                  true
                ),
              },
            },
          }}
          // handleEventHover={handleEventHover}
          // handleEventMouseLeave={handleEventMouseLeave}
          handleEventMount={handleEventMount}
        />

        <Popover
          id={selectedEventDetails?.event?.id}
          open={Boolean(selectedEventDetails?.event)}
          anchorEl={selectedEventDetails?.el}
          onClose={() => setSelectedEventDetails({})}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className={classes.popoverContent}>
            {selectedEventDetails?.event?.extendedProps?.activity?.category ===
            "timeShow" ? (
              <>
                {!selectedEventDetails?.event?.extendedProps?.activity?.details
                  ?.targetTime ? (
                  <span
                    style={{
                      color: "rgba(0,0,0,0.87)",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <img
                      src={restImage}
                      alt=""
                      style={{ width: "35px", height: "35px" }}
                    />{" "}
                    &nbsp; Rest day
                  </span>
                ) : (
                  <>
                    <p
                      class="fc-htmlEventContent-span"
                      style={{ margin: "2px" }}
                    >
                      ⏱️
                      <span
                        className="textLabel"
                        style={{
                          color: "rgba(0,0,0,0.87)",
                          fontWeight: "bold",
                        }}
                      >
                        Target Time:&nbsp;
                      </span>
                      <span>
                        {selectedEventDetails?.event?.extendedProps?.activity
                          ?.details?.targetTime + " Min." || "-"}
                      </span>
                    </p>

                    <p
                      class="fc-htmlEventContent-span"
                      style={{ margin: "2px" }}
                    >
                      🏅
                      <span
                        className="textLabel"
                        style={{
                          color: "rgba(0,0,0,0.87)",
                          fontWeight: "bold",
                        }}
                      >
                        Achieved Time:&nbsp;
                      </span>
                      <span>
                        {selectedEventDetails?.event?.extendedProps?.activity
                          ?.details?.activeTime + " Min." || "-"}
                      </span>
                    </p>
                  </>
                )}
              </>
            ) : (
              selectedEventDetails?.event?.extendedProps?.activity &&
              selectedEventDetails?.event?.extendedProps?.activity?.category !==
                "timeShow" &&
              selectedEventDetails?.event?.extendedProps?.activity.displayColumns
                ?.split(",")
                .filter((x) => x)
                .map((activity) => (
                  <Typography key={activity} className={classes.contentTypo}>
                    <span>{`${labels[activity]}: `}</span>
                    {`${
                      activity === "distance"
                        ? selectedEventDetails?.event?.extendedProps?.activity
                            ?.details["cooperTestDistance"]
                          ? parseFloat(
                              selectedEventDetails?.event?.extendedProps
                                ?.activity?.details["cooperTestDistance"] / 1000
                            ).toFixed(2) + " km"
                          : `0 km`
                        : activity === "remark"
                        ? selectedEventDetails?.event?.extendedProps?.activity
                            ?.details["cooperTestRemark"]
                        : activity === "target"
                        ? selectedEventDetails?.event?.extendedProps?.activity
                            ?.target
                        : activity === "achieved"
                        ? selectedEventDetails?.event?.extendedProps?.activity
                            ?.details["steps"]
                        : selectedEventDetails?.event?.extendedProps?.activity
                            ?.details[activity]
                        ? selectedEventDetails?.event?.extendedProps?.activity
                            ?.details[activity]
                        : "00:00:00"
                      //ankit  Defect_id_485 : if completion time is not send by api set to zero
                    }`}
                  </Typography>
                ))
            )}

            {selectedEventDetails?.event?.extendedProps?.sessionDetails && (
              <Typography className={classes.contentTypo}>
                <span className="popover-session-title">
                  {selectedEventDetails?.event?.title}
                </span>
                <span>
                  {
                    selectedEventDetails?.event?.extendedProps?.sessionDetails
                      ?.day
                  }
                  ,{" "}
                  {`${selectedEventDetails?.event?.extendedProps?.sessionDetails?.time}`}
                </span>
                <br />
                <span>
                  Faculty:{" "}
                  {
                    selectedEventDetails?.event?.extendedProps?.sessionDetails
                      ?.faculty
                  }
                </span>
                <br />

                {selectedEventDetails?.event?.extendedProps?.sessionDetails
                  ?.meetingLink &&
                  moment(
                    selectedEventDetails?.event?.extendedProps?.sessionDetails
                      ?.endDate
                  ).isAfter(moment().format("L")) && (
                    <a
                      className={classes.joinLink}
                      target="_blank"
                      href={
                        selectedEventDetails?.event?.extendedProps
                          ?.sessionDetails?.meetingLink
                      }
                    >
                      Join Here
                    </a>
                  )}
              </Typography>
            )}
            {selectedEventDetails?.event?.extendedProps?.programDetails && (
              <div>
                <Typography className={classes.detailsContentTypo}>
                  <span className="title">
                    {
                      selectedEventDetails?.event?.extendedProps?.programDetails
                        ?.name
                    }
                  </span>
                  <span className="sub-title">
                    {`${selectedEventDetails?.event?.extendedProps?.programDetails?.dateFrom} to ${selectedEventDetails?.event?.extendedProps?.programDetails?.dateTo}`}
                  </span>
                </Typography>
                <Typography className={classes.detailsContentTypo}>
                  <span className="sub-title">
                    {selectedEventDetails?.event?.extendedProps?.programDetails
                      ?.category &&
                    selectedEventDetails?.event?.extendedProps?.programDetails
                      ?.details?.challengeType !== "STAIR_STEPPER"
                      ? `${selectedEventDetails?.event?.extendedProps?.programDetails?.category}`
                      : ""}
                  </span>
                </Typography>
                {/* <Typography className={classes.detailsContentTypo}>
                    <span className="sub-title">
                     Status - Attended
                    </span>
                  </Typography> */}
                {/* <div className={classes.attendContainer}> 
                    <FormControlLabel
                      control={
                        <Checkbox  size="small" color="primary" />
                      }
                      label="Attended"
                    />
                 
                    <FormControlLabel
                      control={<Checkbox size="small" color="primary" />}
                      label="Yet to attended"
                    />
                  
                    <FormControlLabel
                      control={<Checkbox size="small" color="primary" />}
                      label="Abstained"
                    />
                  </div> */}
              </div>
            )}
          </div>
        </Popover>

        {/* <Popover
          id={selectedDayCellContent?.id}
          open={Boolean(selectedDayCellContent?.id)}
          anchorEl={selectedEventDetails?.el}
          onClose={() => setSelectedDayCellContent({})}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className={classes.popoverContent}>
            Target Time: {selectedDayCellContent?.targetTime || "00"}
          </div>
        </Popover> */}
      </div>
    </>
  );
}

const labels = {
  distance: "Distance",
  steps: "Steps",
  completionTime: "Duration",
  target: "Target",
  achieved: "Achieved",
  // remark: "Remark",
};
const styles = (theme) => ({
  calenderContainer: {
    margin: "20px",
    marginTop: "60px",
    position: "relative",
    "& .fc .fc-popover": {
      zIndex: 999,
    },

    "& .fc td": {
      padding: "0px 0 25px 0 !important",
    },

    "& .fc-event-title": {
      fontSize: "17px",
      fontWeight: 600,
      textWrap: "wrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
    },
    "& .fc .fc-daygrid-day-top": {
      minHeight: "38px",
      position: "relative",
      "& a": {
        minHeight: "38px",
        // width: "100%",
        // padding: "3px",
        "& .presentDayEvent": {
          minHeight: "38px",
          padding: "2px",
          fontSize: "12px",
          borderRadius: "2px",
          background: "#3788d8",
          "& span": {
            display: "flex",
            alignItems: "center",
            "& .Labeltext": {
              display: "block",
              [theme.breakpoints.down("xs")]: {
                display: "none",
              },
            },
          },
        },
      },
    },
    "& .fc .fc-daygrid-day-top .a": {
      width: "100%",
    },

    "& .fc-daygrid-month-start": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.6em",
        wordBreak: "break-word",
      },
    },
    "& .fc-daygrid-day-frame": {
      [theme.breakpoints.down("sm")]: {
        minHeight: "150px !important",
      },
    },
    "& .fc-toolbar": {
      flexWrap: "wrap",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "space-evenly",
      },
    },
    "& .fc-button-group": {
      marginTop: "10px",
    },
    "& .fc-toolbar-title": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
    "& .fc-htmlEventContent": {
      padding: "5px",
      display: "block",
      overflowX: "hidden",
      textWrap: "wrap",
      "& p": {
        margin: "3px 0px",
      },
      "& .join-link": {
        lineHeight: "30px",
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#ffffff",
        // padding: "4px",
        borderRadius: "10px",
        color: "#3788d8",
        width: "fit-content",
        paddingInline: "10px",
      },
      "& .fc-htmlEventContent-span": {
        // lineHeight: "22px",
        display: "flex",

        "& .isHideRestDayLabelMobileView": {
          color: "red",
          // display: "block",
          // [theme.breakpoints.down("sm")]: {
          //   display: "none",
          // },
        },
        alignItems: "center",
        "& span:nth-child(2)": {
          display: "block",
          fontSize: "14px",
          fontWeight: "500",
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        },
        "&  .textLabel": {
          display: "block",
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        },
        fontSize: "16px",
        "& span": {
          fontWeight: "bold",
        },
        [theme.breakpoints.down("lg")]: {
          fontSize: "12px",
        },
        [theme.breakpoints.down("md")]: {
          fontSize: "12px",
        },
        [theme.breakpoints.down("sm")]: {
          wordBreak: "break-word",

          fontSize: "10px",
        },
      },
      "& .fc-htmlEventContent-span-title": {
        // lineHeight: "20px",
        fontSize: "16px",
        fontWeight: "bold",
        [theme.breakpoints.down("sm")]: {
          fontSize: "10px",
        },
      },
      "& .fc-mobileLogo": {
        display: "block",
        [theme.breakpoints.up("sm")]: {
          display: "none",
        },
      },
      "& .fc-laptopContent": {
        display: "none",
        [theme.breakpoints.up("sm")]: {
          display: "block",
        },
      },
    },

    "& .restDay": {
      minHeight: "38px",
      flexDirection: "column",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
      "& p": {
        display: "block !important",

        [theme.breakpoints.down("sm")]: {
          display: "none !important",
        },
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
      marginRight: "0px",
      padding: "1px",
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "0px",
      marginRight: "0px",
      padding: "1px",
    },
  },
  contentTypo: {
    fontSize: "15px",
    // lineHeight: "20px",
    "& span": {
      fontWeight: "bold",
    },
  },
  detailsContentTypo: {
    // marginTop: "10px",
    // lineHeight: "20px",
    "& .title": {
      display: "block",
      fontSize: "20px",
      fontWeight: "bold",
      color: "#3788d8",
    },
    "& .sub-title": {
      fontWeight: "bold",
      fontSize: "15px",
      display: "block",
      color: "black",
    },
  },
  attendContainer: {
    marginTop: "10px",
  },
  popoverContent: {
    padding: "10px",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "flex-start",
    "& .popover-session-title": {
      display: "block",
      fontSize: "20px",
      fontWeight: "bold",
      color: "#3788d8",
    },
  },
  joinLink: {
    lineHeight: "30px",
    fontSize: "16px",
    fontWeight: "bold",
    backgroundColor: "#3788d8",
    padding: "5px",
    borderRadius: "10px",
    color: "#ffffff",
  },
});
export default compose(withStyles(styles), withRouter)(CalenderHomeView);
